'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var ExitIntentTrigger = new _immutable.Record({
  enabled: false
}, 'ExitIntentTrigger');

exports.default = ExitIntentTrigger;
module.exports = exports['default'];